import { Component, OnInit } from '@angular/core';
import { MetaService } from 'app/services/meta.service';
import { BaseComponent } from '../base/base.component';
import { FragmentService } from '../../services/fragment.service';

@Component({
    selector: 'app-api-overview',
    templateUrl: './api-overview.component.html',
    standalone: false
})
export class ApiOverviewComponent extends BaseComponent implements OnInit {
  constructor(
    public fragmentService: FragmentService,
    public metaService: MetaService
    ) {
    super(fragmentService, metaService);
   }

  override ngOnInit(): void {
    super.ngOnInit();
  }

}
